package locale

import androidx.compose.ui.text.Placeholder
import feature.auth.handler.AuthHandler
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

fun localization(): Localization {
    return AuthHandler.shared().repository.localization.value
}

@Serializable
data class Localization(
    @SerialName("authentication") var authentication: AuthenticationLocalization = AuthenticationLocalization(),
    @SerialName("customer") var customer: CustomerLocalization = CustomerLocalization(),
    @SerialName("product_menu") var productMenu: ProductMenuLocalization = ProductMenuLocalization(),
    //@SerialName("business") var business: BusinessLocalization = BusinessLocalization(),
    @SerialName("business_menu") var businessMenu: BusinessMenuLocalization = BusinessMenuLocalization()
)

@Serializable
data class AuthenticationLocalization(
    @SerialName("name") var customer: String = "Name",
    @SerialName("mobile_number") var mobileNumber: String = "Mobile Number",
)

@Serializable
data class CustomerLocalization(
    @SerialName("name") var customer: String = "Name",
    @SerialName("mobile_number") var mobileNumber: String = "Mobile Number",
)

@Serializable
data class ProductMenuLocalization(
    @SerialName("products_title") var productsTitle: String = "Products",
    @SerialName("products_search_placeholder") var productsSearchPlaceholder: String = "Search Product",
    @SerialName("products_total") var productsTotal: String = "Total ",
    @SerialName("products_product") var productsProduct: String = " Products",
    @SerialName("products_create_new") var productsCreateNew: String = "Create New Product",
    @SerialName("products_name") var productsName: String = "Name",
    @SerialName("products_name_placeholder") var productsNamePlaceholder: String = "Name Of The Product ",
    @SerialName("products_description") var productsDescription: String = "Description",
    @SerialName("products_description_Placeholder") var productsDescriptionPlaceholder: String = "Detail About Product",
    @SerialName("products_sale_price") var productsSalePrice: String = "Sale Price",
    @SerialName("products_sale_price_placeholder") var productsSalePricePlaceholder: String = "Sale Price",
    @SerialName("products_save_button") var productsSaveButton: String = "Save",
    @SerialName("products_next_button") var productsNextButton: String = "Next",
    @SerialName("products_prev_button") var productsPrevButton: String = "Prev",
    @SerialName("products_alert_title") var productsAlertTitle: String = "Oops",
    @SerialName("products_alert_message") var productsAlertMessage: String = "Something Went Wrong",
    )

@Serializable
data class BusinessLocalization(
   // @SerialName("menu_label_sale") var menuLabelSale: String = "Sale",
    @SerialName("manu_label_sub_category") var menuLabelSubCategory: String = "Sub Category",
    )
@Serializable
data class BusinessMenuLocalization(
    @SerialName("sales") var sale:  String = "Sale",
    @SerialName("inventory") var inventory: String = "Inventory",
    @SerialName("store") var store: String = "Store",
    @SerialName("menu_label_sale") var menuLabelSale: String = "Sale",
    @SerialName("invoice") var invoice: String = "Invoice",
    @SerialName("product") var product: String = "Product",
    @SerialName("category") var category: String = "Category",
    @SerialName("sub_category") var subCategory: String = "Sub Category",
    @SerialName("stock") var stock: String = "Stock",
    @SerialName("store_label") var storeLabel: String = "Store",
    @SerialName("dashboard") var dashboard: String = "Dashboard",
    @SerialName("employee") var employee: String = "Employee",
    @SerialName("customer") var customer: String = "Customer",
    @SerialName("all_business") var allBusiness: String = "All Business",

    )